import { type FC, useState } from 'react';

import Error from '@mui/icons-material/Error';

import { Button } from '@craft/ui/components/buttons';
import { Stack } from '@craft/ui/components/structural';
import { Typography } from '@craft/ui/components/typography';

import { useRouteParamStrings } from '@/src/components/hooks/useRouteParamStrings';

import { LtiErrorDetail } from './LtiErrorDetail';

interface LtiErrorProps {
  readonly errorDetail?: string;
  readonly errorMessage?: string;
}

export const LtiError: FC<LtiErrorProps> = ({ errorDetail, errorMessage }) => {
  const { ltiLoginErrorMessage } = useRouteParamStrings(['ltiLoginErrorMessage']);

  const [showDetail, setShowDetail] = useState(false);

  return (
    <Stack alignItems='center' direction='column' paddingTop={2} spacing={2}>
      <Stack alignItems='center' direction='row' spacing={1}>
        <Error color='error' />
        <Typography variant='h5'>Unable to Open the Craft Connect Page</Typography>
      </Stack>
      <Typography color='text.secondary' variant='body2'>
        There was a problem processing this Craft Connect request.
      </Typography>
      {(ltiLoginErrorMessage || errorMessage) && (
        <Typography>{ltiLoginErrorMessage ?? errorMessage}</Typography>
      )}
      {errorDetail && (
        <Button.Small onClick={() => setShowDetail(!showDetail)}>
          {showDetail ? 'Hide Details' : 'Show Details'}
        </Button.Small>
      )}
      {showDetail && <LtiErrorDetail errorDetail={errorDetail ?? ''} />}
    </Stack>
  );
};
